import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFVideoPlayer } from '@/components/UI/svg/mm100';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp() {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const videoSourceMap = {
        us: 'https://www.youtube.com/embed/6iJBWYIb1bo',
        jp: 'https://www.youtube.com/embed/Jw50ZZtAUcI',
        cn: {
            SD: 'https://videos.ecoflow.com/61003a32172a4caf8bda51f228995a3c/a2198a171f19474597cec3ee89132eb8-781e83b2f39070ad55c8dfca996705fe-fd.mp4',
            HD: 'https://videos.ecoflow.com/61003a32172a4caf8bda51f228995a3c/a2198a171f19474597cec3ee89132eb8-d33ea19768f7890d4549d6d6a56e98e8-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/20a2ba87-1841d5c8d02-0004-9c91-e6d-40030.mp4',
        },
    };

    const playerVideo = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'Power Kits Intro Video',
            position: 'Product_1',
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.kitB} kitB`}>
            <div className="kit-ms1">{t(locale === 'kr' ? 'presale.product.kitB_ms1_h5' : 'presale.product.kitB_ms1')}</div>
            <div className="btn-box">
                <div className="kit-btn" onClick={playerVideo}>
                    <div className="kit-btn__box">
                        <div className="kit-btn__text">{t('presale.product.kitB_btn')}</div>
                        <EFVideoPlayer className="kit-btn__svg" width="0.18rem" height="0.18rem" />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
